"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Modality.css");
var _Remove_icon = _interopRequireDefault(require("../assets/Remove_icon.png"));
var _Add_icon = _interopRequireDefault(require("../assets/Add_icon.png"));
var _Edit_icon = _interopRequireDefault(require("../assets/Edit_icon.png"));
var _IconStatus = _interopRequireDefault(require("../components/IconStatus"));
var _Speech_icon = _interopRequireDefault(require("../assets/Speech_icon.png"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _TextareaInput = _interopRequireDefault(require("./TextareaInput"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : Modality.js
* Description : Ce fichier contient la définition du composant Modality 
*               Ce composant affiche toutes les informations d'une modalité d'essai
* Date de création : 21 juillet 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ //import { evaluate } from "mathjs";
/* Hook */ /**
* Modality : ce composant affiche toutes les informations d'une modalité d'essai
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu de l'élément à afficher
*/
function Modality(_ref) {
  var modality = _ref.modality,
    product_id = _ref.product_id,
    product_version_name = _ref.product_version_name,
    handleRemove = _ref.handleRemove,
    protocole = _ref.protocole,
    onModalityBlockChange = _ref.onModalityBlockChange;
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setDataLoading = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    treatmentApplications = _useState4[0],
    setTreatmentApplications = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    treatmentApplicationAdd = _useState6[0],
    setTreatmentApplicationAdd = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    treatmentApplicationUpdate = _useState8[0],
    setTreatmentApplicationUpdate = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    treatmentParameterAdd = _useState0[0],
    setTreatmentParameterAdd = _useState0[1];
  var _useState1 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState1, 2),
    applicationOrder = _useState10[0],
    setApplicationOrder = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    distance = _useState12[0],
    setDistance = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    nbTotalRecurrence = _useState14[0],
    setNbTotalRecurrence = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    nbRecurrence = _useState16[0],
    setNbRecurrence = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    commentUpdate = _useState18[0],
    setCommentUpdate = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    comment = _useState20[0],
    setComment = _useState20[1];
  var _useState21 = (0, _react.useState)([]),
    _useState22 = _slicedToArray(_useState21, 2),
    ptuTypes = _useState22[0],
    setPtuTypes = _useState22[1];
  var _useState23 = (0, _react.useState)(0),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedPtuType = _useState24[0],
    setSelectedPtuType = _useState24[1];
  var _useState25 = (0, _react.useState)(0),
    _useState26 = _slicedToArray(_useState25, 2),
    newFrequence = _useState26[0],
    setNewFrequence = _useState26[1];
  var _useState27 = (0, _react.useState)(0),
    _useState28 = _slicedToArray(_useState27, 2),
    newPulseWidth = _useState28[0],
    setNewPulseWidth = _useState28[1];
  var _useState29 = (0, _react.useState)(0),
    _useState30 = _slicedToArray(_useState29, 2),
    newDuration = _useState30[0],
    setNewDuration = _useState30[1];
  var _useState31 = (0, _react.useState)(0),
    _useState32 = _slicedToArray(_useState31, 2),
    newDelay = _useState32[0],
    setNewDelay = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    modalityUpdate = _useState34[0],
    setModalityUpdate = _useState34[1];
  var _useState35 = (0, _react.useState)(""),
    _useState36 = _slicedToArray(_useState35, 2),
    reference = _useState36[0],
    setReference = _useState36[1];
  var _useState37 = (0, _react.useState)(0),
    _useState38 = _slicedToArray(_useState37, 2),
    selectedValidationStatus = _useState38[0],
    setSelectedValidationStatus = _useState38[1];
  var _useState39 = (0, _react.useState)(-1),
    _useState40 = _slicedToArray(_useState39, 2),
    frequenceApplication = _useState40[0],
    setFrequenceApplication = _useState40[1];
  var _useState41 = (0, _react.useState)(false),
    _useState42 = _slicedToArray(_useState41, 2),
    referenceError = _useState42[0],
    setReferenceError = _useState42[1];
  var _useState43 = (0, _react.useState)(false),
    _useState44 = _slicedToArray(_useState43, 2),
    validationStatusError = _useState44[0],
    setValidationStatusError = _useState44[1];
  var _useState45 = (0, _react.useState)(false),
    _useState46 = _slicedToArray(_useState45, 2),
    frequenceApplicationError = _useState46[0],
    setFrequenceApplicationError = _useState46[1];
  var _useState47 = (0, _react.useState)(false),
    _useState48 = _slicedToArray(_useState47, 2),
    modalitySubmit = _useState48[0],
    setModalitySubmit = _useState48[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path;
  var _useData = (0, _dist.useData)(),
    validationStatus = _useData.validationStatus;

  // Define useBlocker hooks
  var modalityBlock = modalityUpdate || treatmentApplicationAdd || treatmentParameterAdd !== null || commentUpdate;

  // Define functions
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resTreatmentApplication, _yield$Promise$all3, _yield$Promise$all4, dataTreatmentApplication;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Requests in parallel to win time
            _context.n = 1;
            return Promise.all([
            // Retrieve treatment applications linked to modality
            fetch(path + "/api/bo-trap/?modality_id=" + modality.id, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            resTreatmentApplication = _yield$Promise$all2[0];
            _context.n = 2;
            return Promise.all([resTreatmentApplication.json()]);
          case 2:
            _yield$Promise$all3 = _context.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 1);
            dataTreatmentApplication = _yield$Promise$all4[0];
            // Set variables
            setTreatmentApplications(dataTreatmentApplication["results"]);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  function retrievePtuTypes() {
    return _retrievePtuTypes.apply(this, arguments);
  }
  function _retrievePtuTypes() {
    _retrievePtuTypes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, response, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve list of PTU type
            _context2.n = 1;
            return fetch(path + "/api/eq-ptty/?product_id=" + product_id + "&product_version=" + product_version_name, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            response = _context2.v;
            _context2.n = 2;
            return response.json();
          case 2:
            data = _context2.v;
            setPtuTypes(data["results"]);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _retrievePtuTypes.apply(this, arguments);
  }
  var handleModalityUpdate = function handleModalityUpdate(event) {
    event.preventDefault();
    setModalityUpdate(true);
  };
  var handleModalitySubmit = function handleModalitySubmit(event) {
    event.preventDefault();
    if (reference === null || reference === '') {
      setReferenceError(true);
    } else {
      setReferenceError(false);
    }
    if (selectedValidationStatus === 0 || selectedValidationStatus === '0') {
      setValidationStatusError(true);
    } else {
      setValidationStatusError(false);
    }
    if (frequenceApplication === -1) {
      setFrequenceApplicationError(true);
    } else {
      setFrequenceApplicationError(false);
    }
    setModalitySubmit(true);
  };
  var handleModalityCancel = function handleModalityCancel(event) {
    event.preventDefault();
    setModalityUpdate(false);
  };
  function sendModalityUpdate(_x, _x2, _x3, _x4, _x5) {
    return _sendModalityUpdate.apply(this, arguments);
  }
  function _sendModalityUpdate() {
    _sendModalityUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(trial_id, reference, comments, validation_status_id, application_frequence) {
      var token, json_data;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Création du JSON
            if (comment === "") {
              json_data = JSON.stringify({
                "trial_id": trial_id,
                "reference": reference,
                "validation_status_id": validation_status_id,
                "application_frequence": application_frequence
              });
            } else {
              json_data = JSON.stringify({
                "trial_id": trial_id,
                "reference": reference,
                "validation_status_id": validation_status_id,
                "comments": comments,
                "application_frequence": application_frequence
              });
            }
            // create modality
            _context3.n = 1;
            return fetch(path + "/api/bo-moty/" + modality.id + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              },
              body: json_data
            });
          case 1:
            setModalitySubmit(false);
            retrieveData();
            setModalityUpdate(false);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _sendModalityUpdate.apply(this, arguments);
  }
  var handleClickTreatmentApplicationAdd = function handleClickTreatmentApplicationAdd(event) {
    event.preventDefault();
    if (treatmentApplicationAdd === false) {
      setTreatmentApplicationAdd(true);
    } else {
      setTreatmentApplicationAdd(false);
      setApplicationOrder(0);
      setDistance(0);
      setNbRecurrence(0);
    }
  };
  var handleTreatmentApplicationSubmit = function handleTreatmentApplicationSubmit(event) {
    event.preventDefault();
    createTreatmentApplication(modality.id, distance, nbRecurrence, applicationOrder);
  };
  var handleTreatmentApplicationCancel = function handleTreatmentApplicationCancel(event) {
    event.preventDefault();
    setTreatmentApplicationAdd(false);
    setApplicationOrder(0);
    setDistance(0);
    setNbRecurrence(0);
  };
  function createTreatmentApplication(_x6, _x7, _x8, _x9) {
    return _createTreatmentApplication.apply(this, arguments);
  }
  function _createTreatmentApplication() {
    _createTreatmentApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(modality_id, distance, nb_recurrence, application_order) {
      var token;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // create modality
            _context4.n = 1;
            return fetch(path + "/api/bo-trap/", {
              method: 'POST',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              },
              body: JSON.stringify({
                "modality_id": modality_id,
                "distance": distance,
                "nb_recurrence": nb_recurrence,
                'application_order': application_order
              })
            });
          case 1:
            retrieveData();
            setTreatmentApplicationAdd(false);
            computeTotalRecurrence();
            setApplicationOrder(0);
            setDistance(0);
            setNbRecurrence(0);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _createTreatmentApplication.apply(this, arguments);
  }
  var handleTreatmentApplicationUpdateSubmit = function handleTreatmentApplicationUpdateSubmit(event, id) {
    event.preventDefault();
    updateTreatmentApplication(id, modality.id, distance, nbRecurrence, applicationOrder);
  };
  function updateTreatmentApplication(_x0, _x1, _x10, _x11, _x12) {
    return _updateTreatmentApplication.apply(this, arguments);
  }
  function _updateTreatmentApplication() {
    _updateTreatmentApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, modality_id, distance, nb_recurrence, application_order) {
      var token;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // update treatment application
            _context5.n = 1;
            return fetch(path + "/api/bo-trap/" + id + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              },
              body: JSON.stringify({
                "modality_id": modality_id,
                "distance": distance,
                "nb_recurrence": nb_recurrence,
                'application_order': application_order
              })
            });
          case 1:
            retrieveData();
            setTreatmentApplicationUpdate(0);
            computeTotalRecurrence();
            setApplicationOrder(0);
            setDistance(0);
            setNbRecurrence(0);
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return _updateTreatmentApplication.apply(this, arguments);
  }
  var handleApplicationRemove = function handleApplicationRemove(event, treatment_application_id) {
    event.preventDefault();
    removeTreatmentApplication(treatment_application_id);
  };
  var handleApplicationEdit = function handleApplicationEdit(event, treatment_application) {
    event.preventDefault();
    setTreatmentApplicationUpdate(treatment_application.id);
    setApplicationOrder(treatment_application.application_order);
    setDistance(treatment_application.distance);
    setNbRecurrence(treatment_application.nb_recurrence);
  };
  var handleTreatmentApplicationUpdateCancel = function handleTreatmentApplicationUpdateCancel(event) {
    event.preventDefault();
    setTreatmentApplicationUpdate(0);
    setApplicationOrder(0);
    setDistance(0);
    setNbRecurrence(0);
  };
  function removeTreatmentApplication(_x13) {
    return _removeTreatmentApplication.apply(this, arguments);
  }
  function _removeTreatmentApplication() {
    _removeTreatmentApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(item_id) {
      var token;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Delete treatment application
            _context6.n = 1;
            return fetch(path + "/api/bo-trap/" + item_id + "/", {
              method: 'DELETE',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              }
            });
          case 1:
            retrieveData();
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return _removeTreatmentApplication.apply(this, arguments);
  }
  var commentEditIcon = function commentEditIcon(event) {
    event.preventDefault();
    setComment(modality["comments"]);
    setCommentUpdate(true);
  };
  var handleKeyDown = function handleKeyDown(event) {
    // Si la touche Entrée est pressée, empêche la validation du formulaire
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
    }
  };
  var commentUpdateSubmit = function commentUpdateSubmit(event) {
    event.preventDefault();
    sendCommentUpdate(comment);
  };
  var commentUpdateReset = function commentUpdateReset(event) {
    event.preventDefault();
    setComment(null);
    setCommentUpdate(false);
  };
  function sendCommentUpdate(_x14) {
    return _sendCommentUpdate.apply(this, arguments);
  }
  function _sendCommentUpdate() {
    _sendCommentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(comment) {
      var token;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // update comment
            _context7.n = 1;
            return fetch(path + "/api/bo-moty/" + modality.id + "/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              },
              body: JSON.stringify({
                "comments": comment
              })
            });
          case 1:
            setCommentUpdate(false);
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return _sendCommentUpdate.apply(this, arguments);
  }
  var handleClickTreatmentParameterAdd = function handleClickTreatmentParameterAdd(event, index) {
    event.preventDefault();
    if (treatmentParameterAdd === null) {
      setTreatmentParameterAdd(index);
    } else {
      setTreatmentParameterAdd(null);
    }
  };
  var handleParameterSubmit = function handleParameterSubmit(event, application_id) {
    event.preventDefault();
    createTreatmentParameter(newFrequence, newPulseWidth, newDuration, newDelay, application_id, selectedPtuType);
  };
  function createTreatmentParameter(_x15, _x16, _x17, _x18, _x19, _x20) {
    return _createTreatmentParameter.apply(this, arguments);
  }
  function _createTreatmentParameter() {
    _createTreatmentParameter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(frequence, pulse_width, duration, delay, treatment_application_id, ptu_type_id) {
      var token;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // create treatment parameter
            _context8.n = 1;
            return fetch(path + "/api/bo-trpa/", {
              method: 'POST',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              },
              body: JSON.stringify({
                "frequence": frequence,
                "pulse_width": pulse_width,
                "duration": duration,
                "delay": delay,
                "treatment_application_id": treatment_application_id,
                "ptu_type_id": ptu_type_id
              })
            });
          case 1:
            retrieveData();
            setTreatmentParameterAdd(null);
            setNewFrequence(0);
            setNewPulseWidth(0);
            setNewDuration(0);
            setNewDelay(0);
            setSelectedPtuType(0);
          case 2:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return _createTreatmentParameter.apply(this, arguments);
  }
  var handleParameterRemove = function handleParameterRemove(event, treatment_parameter_id) {
    event.preventDefault();
    removeTreatmentParameter(treatment_parameter_id);
  };
  function removeTreatmentParameter(_x21) {
    return _removeTreatmentParameter.apply(this, arguments);
  }
  function _removeTreatmentParameter() {
    _removeTreatmentParameter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(item_id) {
      var token;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Delete treatment parameter
            _context9.n = 1;
            return fetch(path + "/api/bo-trpa/" + item_id + "/", {
              method: 'DELETE',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token
              }
            });
          case 1:
            retrieveData();
          case 2:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    return _removeTreatmentParameter.apply(this, arguments);
  }
  function computeTotalRecurrence() {
    var totalRecurrence = 0;
    var _iterator = _createForOfIteratorHelper(treatmentApplications),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        totalRecurrence += element.nb_recurrence;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setNbTotalRecurrence(totalRecurrence);
  }

  /*function function_dPower(expression, distance) {
      const dPower = evaluate(expression, {
          x: Number(distance)
      });
      return dPower
  }*/

  function function_dose(distance, treatment_parameter) {
    var dPower = (0, _dist.function_dPower)(treatment_parameter.ptu_type.transfer_function, distance);
    var duration = treatment_parameter.duration;
    var pulse_width = treatment_parameter.pulse_width;
    var dose = dPower * duration * pulse_width / 100;
    return dose.toFixed(2);
  }

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    setDataLoading(true);
    setReference(modality.reference);
    setSelectedValidationStatus(modality.validation_status.id);
    setFrequenceApplication(modality.application_frequence);
    setComment(modality.comments);
    retrievePtuTypes();
    retrieveData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    computeTotalRecurrence();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentApplications]);
  (0, _react.useEffect)(function () {
    if (onModalityBlockChange) {
      onModalityBlockChange(modalityBlock);
    }
  }, [modalityBlock, onModalityBlockChange]);
  (0, _react.useEffect)(function () {
    if (modalitySubmit === true && referenceError === false && validationStatusError === false && frequenceApplicationError === false) {
      sendModalityUpdate(modality.trial_id, reference, comment, selectedValidationStatus, frequenceApplication);
    } else {
      setModalitySubmit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalitySubmit]);

  // Render component
  return isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Chargement des donn\xE9es"
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "modality-border",
    children: [protocole === false ? modalityUpdate === true ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "modality-border grid-1-10-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "margin-right",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "modality-subtitle",
          children: "R\xE9f\xE9rence : "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: referenceError === false ? 'form-input' : 'form-input-error',
          type: "text",
          placeholder: "Entrer une r\xE9f\xE9rence",
          value: reference,
          onChange: function onChange(e) {
            return setReference(e.target.value);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "modality-subtitle",
          children: "Status : "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: "select-form-tr",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
            name: "selectedChoice",
            className: validationStatusError === false ? 'select-form-option' : 'select-form-error',
            value: selectedValidationStatus,
            onChange: function onChange(e) {
              return setSelectedValidationStatus(e.target.value);
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
              value: 0,
              children: "--Selectionnez un status--"
            }), validationStatus.map(function (choice) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                value: choice['id'],
                children: choice['name']
              }, choice['id']);
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "modality-subtitle",
          children: "Intervalle \xE0 respecter entre chaque application (jours) : "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: frequenceApplicationError === false ? 'form-input' : 'form-input-error',
          type: "float",
          value: frequenceApplication,
          onChange: function onChange(e) {
            return setFrequenceApplication(e.target.value);
          }
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "modality-subtitle",
          children: "Conditions : "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextareaInput["default"], {
          type: "text",
          placeholder: "Entrer les conditions de la modalit\xE9",
          value: comment,
          setValue: setComment,
          onKeyDown: handleKeyDown
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: handleModalitySubmit,
          className: "button",
          children: "Valider"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: handleModalityCancel,
          className: "button",
          children: "Annuler"
        })]
      })]
    }, 0) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "grid-1-10-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex-column",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Ref : "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-text",
              children: modality['reference']
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconStatus["default"], {
            color: modality["validation_status"]["color"]
          })
        })]
      }), currentUser["role_name"] === "AT_ADMIN" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "modality-subtitle",
          children: "Conditions"
        }), comment !== "" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            whiteSpace: 'pre-line'
          },
          children: comment
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "table-cell table-data",
          children: "Aucune condition."
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex-row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "modality-subtitle",
            children: "Conditions"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _Edit_icon["default"],
            alt: "edit_item_icon",
            onClick: function onClick(e) {
              return commentEditIcon(e);
            },
            className: "link-img link-icon"
          })]
        }), commentUpdate === true ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
          onSubmit: commentUpdateSubmit,
          onReset: commentUpdateReset,
          className: "flex-row justify-end",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextareaInput["default"], {
            value: comment,
            setValue: setComment,
            onKeyDown: handleKeyDown
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "reset",
            className: "button",
            children: "Annuler"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "submit",
            className: "button",
            children: "Valider"
          })]
        }) : comment !== "" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            whiteSpace: 'pre-line'
          },
          children: comment
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "table-cell table-data",
          children: "Aucune condition."
        })]
      }), currentUser["role_name"] === "AT_ADMIN" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex-row justify-end",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Edit_icon["default"],
          alt: "edit_item_icon",
          onClick: function onClick(e) {
            return handleModalityUpdate(e);
          },
          className: "link-img link-icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Remove_icon["default"],
          alt: "remove_item_icon",
          onClick: function onClick(e) {
            return handleRemove(e, modality.id);
          },
          className: "link-img link-icon"
        })]
      }) : null]
    }) : comment !== "" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "modality-subtitle",
        children: "Conditions "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
        title: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: comment
        }),
        arrow: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Speech_icon["default"],
          alt: "speech_icon"
        })
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "link",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
        className: "table-cell table-label",
        children: "Applications "
      }), protocole === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _Add_icon["default"],
        alt: "add_item_icon",
        onClick: handleClickTreatmentApplicationAdd,
        className: "link-img link-icon"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "margin-right-large"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "modality-subtitle",
        children: [nbTotalRecurrence, " application(s) avec un intervalle de ", modality['application_frequence'], " jours"]
      })]
    }), treatmentApplicationAdd === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "grid-1-1-1-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "modality-subtitle",
            children: "Ordre d'application : "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "modality-subtitle",
            children: "Distance de la cible (cm): "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "modality-subtitle",
            children: "Nombre de r\xE9currence : "
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "grid-1-1-1-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: " margin-right-large",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              className: "form-input",
              type: "number",
              value: applicationOrder,
              onChange: function onChange(e) {
                return setApplicationOrder(e.target.value);
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: " margin-right-large",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              className: "form-input margin-right",
              type: "number",
              value: distance,
              onChange: function onChange(e) {
                return setDistance(e.target.value);
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: " margin-right-large",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              className: "form-input margin-right",
              type: "number",
              value: nbRecurrence,
              onChange: function onChange(e) {
                return setNbRecurrence(e.target.value);
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "grid-1-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: handleTreatmentApplicationSubmit,
              className: "button",
              children: "Valider"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: handleTreatmentApplicationCancel,
              className: "button",
              children: "Annuler"
            })]
          })]
        })]
      })
    }, 0) : null, treatmentApplications && treatmentApplications.length !== 0 ? treatmentApplications.sort(function (a, b) {
      return a.application_order > b.application_order ? 1 : -1;
    }).map(function (treatmentApplication, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [treatmentApplicationUpdate === treatmentApplication['id'] ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "grid-1-1-1-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Ordre d'application : "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Distance de la cible (cm): "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Nombre de r\xE9currence : "
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "grid-1-1-1-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: " margin-right-large",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                className: "form-input",
                type: "number",
                value: applicationOrder,
                onChange: function onChange(e) {
                  return setApplicationOrder(e.target.value);
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: " margin-right-large",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                className: "form-input margin-right",
                type: "number",
                value: distance,
                onChange: function onChange(e) {
                  return setDistance(e.target.value);
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: " margin-right-large",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                className: "form-input margin-right",
                type: "number",
                value: nbRecurrence,
                onChange: function onChange(e) {
                  return setNbRecurrence(e.target.value);
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "grid-1-1",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                onClick: function onClick(e) {
                  return handleTreatmentApplicationUpdateSubmit(e, treatmentApplication['id']);
                },
                className: "button",
                children: "Valider"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                onClick: handleTreatmentApplicationUpdateCancel,
                className: "button",
                children: "Annuler"
              })]
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: protocole === false ? 'application-border grid-1-1-1-1' : 'application-border grid-1-1-1',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Odre d'application : "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-text",
              children: treatmentApplication['application_order']
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Distance de la cible (cm): "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-text",
              children: treatmentApplication['distance']
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Nombre de r\xE9currence : "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-text",
              children: treatmentApplication['nb_recurrence']
            })]
          }), protocole === false ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Ajouter des param\xE8tres "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Add_icon["default"],
              alt: "add_item_icon",
              onClick: function onClick(e) {
                return handleClickTreatmentParameterAdd(e, index);
              },
              className: "link-img link-icon"
            })]
          }) : null, protocole === false && currentUser["role_name"] === "AT_ADMIN" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Modifier l'application "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Edit_icon["default"],
              alt: "edit_item_icon",
              onClick: function onClick(e) {
                return handleApplicationEdit(e, treatmentApplication);
              },
              className: "link-img link-icon"
            })]
          }) : null, protocole === false && currentUser["role_name"] === "AT_ADMIN" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "modality-subtitle",
              children: "Supprimer l'application "
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Remove_icon["default"],
              alt: "remove_item_icon",
              onClick: function onClick(e) {
                return handleApplicationRemove(e, treatmentApplication['id']);
              },
              className: "link-img link-icon"
            })]
          }) : null]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
          className: "margin-bottom",
          component: _Paper["default"],
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
            sx: {
              minWidth: 650
            },
            size: "small",
            "aria-label": "a dense table",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "Type de PTU"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "Fr\xE9quence (Hz)"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "Rapport cyclique (%)"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "Dur\xE9e (s)"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "D\xE9lai (s)"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "dPuissance (mW/cm\xB2)"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: "Dose (mJ/cm\xB2)"
                  })
                }), protocole === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    className: "table-label",
                    children: " "
                  })
                }) : null]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableBody["default"], {
              children: [treatmentParameterAdd === index ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                sx: {
                  '&:last-child td, &:last-child th': {
                    border: 0
                  }
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  component: "th",
                  scope: "row",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                    className: "select-form-tr",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
                      className: "select-form-option",
                      value: selectedPtuType,
                      onChange: function onChange(e) {
                        return setSelectedPtuType(e.target.value);
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                        value: 0,
                        children: '--Type de PTU--'
                      }), ptuTypes.map(function (ptuType) {
                        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                          value: ptuType['id'],
                          children: ptuType['reference']
                        }, ptuType['id']);
                      })]
                    })
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                    className: "form-input",
                    type: "number",
                    value: newFrequence,
                    onChange: function onChange(e) {
                      return setNewFrequence(e.target.value);
                    }
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                    className: "form-input",
                    type: "number",
                    value: newPulseWidth,
                    onChange: function onChange(e) {
                      return setNewPulseWidth(e.target.value);
                    }
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                    className: "form-input",
                    type: "number",
                    value: newDuration,
                    onChange: function onChange(e) {
                      return setNewDuration(e.target.value);
                    }
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                    className: "form-input",
                    type: "number",
                    value: newDelay,
                    onChange: function onChange(e) {
                      return setNewDelay(e.target.value);
                    }
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: " "
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: " "
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleParameterSubmit(e, treatmentApplication.id);
                    },
                    className: "button",
                    children: "Valider"
                  })
                })]
              }, 0) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow["default"], {}), treatmentApplication['treatment_parameters'] && treatmentApplication['treatment_parameters'] !== 0 ? treatmentApplication['treatment_parameters'].map(function (treatmentParameter) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                  sx: {
                    '&:last-child td, &:last-child th': {
                      border: 0
                    }
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    component: "th",
                    scope: "row",
                    children: treatmentParameter.ptu_type.reference
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: treatmentParameter.frequence
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: treatmentParameter.pulse_width
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: treatmentParameter.duration
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: treatmentParameter.delay
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: (0, _dist.function_dPower)(treatmentParameter.ptu_type.transfer_function, treatmentApplication['distance'])
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: function_dose(treatmentApplication['distance'], treatmentParameter)
                  }), protocole === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: _Remove_icon["default"],
                      alt: "remove_item_icon",
                      onClick: function onClick(e) {
                        return handleParameterRemove(e, treatmentParameter.id);
                      },
                      className: "link-img link-icon"
                    })
                  }) : null]
                }, treatmentParameter.id);
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  className: "table-cell-margin",
                  children: "Aucuns param\xE8tres actuellement. Veuillez en ajouter !"
                })
              })]
            })]
          })
        })]
      }, treatmentApplication['id']);
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "table-cell-margin",
        children: "Aucune application de traitement actuellement. Veuillez en ajouter !"
      })
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
Modality.propTypes = {
  modality: _propTypes["default"].object,
  handleRemove: _propTypes["default"].func,
  protocole: _propTypes["default"].bool
};
var _default = exports["default"] = Modality;